const AdditionalInformation = function(app) {

  const _ = require('lodash');
  const $ = require('jquery');
  const $container = app.$container;

  const createButton = (data) => {
    return `<div
      tabindex="0"
      role="button"
      data-method="${data.method}"
      class="fc-link-button fc-link-${data.className}">
        ${data.name}
      </div>`;
  };

  const checkProductFacets = () => {
    return _.head(
      _.filter(app.product.facets, (fv, f) => f === 'Skip Product Information')
    );
  };

  const init = () => {
    const btns = [{
      alias: 'size',
      className: 'size-chart',
      facet: 'Size Chart'
    }, {
      alias: 'fit',
      className: 'fit-guide',
      facet: 'Fit Guide'
    }, {
      alias: 'fabric',
      className: 'fabric-details',
      facet: 'Fabric Details'
    }];

    const skipProductInfo = checkProductFacets();
    let markup = '';

    _.forEach(btns, (btn) => {
      if ( app.helpers.hasAttribute(btn.alias) ) {
        const selected = app.helpers.getSelectedValueByAlias(btn.alias);
        const metadata = selected && selected.metadata ? app.utils.getMetaData(selected) : '';
        const productFacetOverride = _.indexOf(skipProductInfo, btn.facet) < 0;

        if ( metadata.after_hook_label && productFacetOverride ) {
          markup += createButton({
            method: metadata.after_hook_callback,
            name: app.l10n.getLang(metadata.after_hook_label),
            className: btn.className
          });
        }
      }
    });

    $container
      .find('.fc-additional-information')
      .html(markup)
      .on('click', '.fc-link-button', (e) => {
        const method = $(e.target).data('method');
        let styleNumber = app.helpers.getFacetsByAlias('oms_sku')['style_#'];
        styleNumber = (!styleNumber) ? {name: ''} : styleNumber;

        window[method](styleNumber.name);
      });
  };

  return {
    init
  };
};

module.exports = AdditionalInformation;